;(() => {
  const updateSections = async () => {
    const { cartSections } = window.BAO.sectionRenderer

    const sectionHtml = await window.BAO.sectionRenderer.fetch(
      cartSections.map(s => s.section),
    )

    window.BAO.sectionRenderer.renderMultiple(
      cartSections.map(s =>
        Object.assign({}, s, { html: sectionHtml[s.section] }),
      ),
    )
  }

  window.BAO.eventBus.addEventListener(
    window.BAO.EVENTS.PUSH_CART.CHANGED,
    updateSections.bind(this),
  )
})()
